"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MODAL_FOOTER_ALIGN", {
  enumerable: true,
  get: function get() {
    return _footerAlignment["default"];
  }
});
exports.ModalFooter = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _oxygenConfig = require("@8x8/oxygen-config");

var _ModalFooter = _interopRequireDefault(require("../styled/ModalFooter.styled"));

var _footerAlignment = _interopRequireDefault(require("../constants/footerAlignment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ModalFooter = function ModalFooter(_ref) {
  var children = _ref.children,
      passThroughProps = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/_react["default"].createElement(_ModalFooter["default"], passThroughProps, children);
};

exports.ModalFooter = ModalFooter;
ModalFooter.propTypes = {
  hasBorderTop: _propTypes["default"].bool,
  hasButtonSpacing: _propTypes["default"].bool,
  isSmall: _propTypes["default"].bool,
  align: _propTypes["default"].oneOf(Object.values(_footerAlignment["default"])),
  children: _propTypes["default"].node,
  testId: _propTypes["default"].string,
  theme: _propTypes["default"].object.isRequired
};
ModalFooter.defaultProps = {
  hasBorderTop: false,
  hasButtonSpacing: true,
  isSmall: false,
  align: _footerAlignment["default"].LEFT,
  children: null,
  testId: 'MODAL_FOOTER'
};

var _default = (0, _oxygenConfig.withTheme)(ModalFooter, 'modal');

exports["default"] = _default;